import { BaseModel } from "../../base.model";
import { PersonPosition } from "../../people/people/person-position.model";
import { Person } from "../../people/people/person.model";
import { EventParking } from "../event-parking.model";
import { Identifier } from "../identifier.model";
import { EventGuestAccreditation } from "./event-guest-accreditation.model";
import { EventGuestInformation } from "./event-guest-information.model";
import { EventGuestNotes } from "./event-guest-notes.model";
import { EventGuestVehicle } from "./event-guest-vehicle.model";
import { MailingGuestList } from "./mailing-guest-list.model";
import { EventGuestCheckIn } from "./event-guest-check-in.model";
import { EventGuestZone } from "./event-guest-zone.model";
import { EventGuestDetails } from "./event-guest-details.model";
import { EventGuestMailing } from "./event-guest-mailing.model";
import { Tag } from "../../common/tag.model";
import { SpaceZoneFilterValue } from "../../events/space-zone-filter.model";

export class EventGuest extends BaseModel {
    mode: string;
    company_id: number;
    event_id: number;
    person_id: number;
    event_person_order: number;
    person_position_id: number | null;
    name: string;
    surname: string;
    lastname: string;
    confirmation_status: string;
    confirmation_date: string | null;
    person_position_order: number | null;
    position: string;
    position_group_name: string;
    color: string;
    identify_id: number | null;
    fK_events_guests_identifiers: Identifier;
    incidents: boolean;
    notPosition: boolean;
    photo: string;
    invitation_mail_status: string;
    invitation_mail_date: string | null;
    parking_mail_status: string;
    parking_mail_date: string | null;
    menu_mail_status: string;
    menu_mail_date: string | null;
    program_mail_status: string;
    program_mail_date: string | null;
    accreditation_mail_status: string;
    accreditation_mail_date: string | null;
    notes: string;
    referrer_person_id: number | null;
    referred_in: string;
    referred_option: string;
    mailings_guests_list: MailingGuestList[];
    namesColumnMailings: string[];
    send_status: string;
    send_date: string | null;
    send_error: string;
    person_information: EventGuestInformation[];
    guest_notes: EventGuestNotes[];
    is_companions_allowed: boolean | null;
    num_companions: number;
    allow_parking: boolean;
    num_vehicles: number;
    max_vehicles_allowed: number;
    zone_id: number;
    zone: string;
    zone_type: string;
    zone_file: string;
    zone_position: string;
    zone_prefered: string;
    locked: boolean;
    parking_name: string;
    group_id: number | null;
    preferred_order: number | null;
    group_name: string;
    groupsIds: number[];
    event_guest_accreditation_id: number | null;
    FK_events_guests_events_guests_accreditations: EventGuestAccreditation;
    fK_events_guests_persons: Person;
    fK_events_guests_persons1: Person;
    fK_events_guests_persons_positions: PersonPosition;
    FK_events_guests_events_parkings: EventParking;
    fK_events_guests_events_guests_vehicles: EventGuestVehicle[];
    invitation_has_been_sent: boolean;
    send_invitation: boolean;
    article_10: boolean;    
    guid: string;
    ciphered_info: string;
    effective_position_order: number | null;
    show_effective_position_order: boolean;
    partial_attendance: boolean | null;
    spaceZonesCombo: string | null;
    check_in_date: string | null;
    FK_events_guests_check_in_events_guests: EventGuestCheckIn[]
    access_status: number;
    FK_events_guests_zones_events_guests: EventGuestZone[];
    zones: EventGuestZone[];
    groupTree: any[];
    details: EventGuestDetails;
    Mailings: EventGuestMailing[];
    Tags?: Tag[];
    zoneFilterValues?: SpaceZoneFilterValue[];
    dirtyDetails?: boolean;
    relatedGuests?: EventGuest[];
    relatedSearchText?: string;
    referrerFullname?: string;
    companionNames?: string;
}
